import mobileAdjustment from '../GeneralMobileAdjustments';

class MobileTableControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        element.css({'height':'', 'textAlign': 'left', 'overflowX': 'scroll'});
        element.parent().css({'minWidth': '100%'});
        let header = element.find('.ui-jqgrid-hdiv');
        header.css({'height': 'auto'});
      }

}

const mobileTableControlView = new MobileTableControlView();
export default mobileTableControlView;